var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "hero_text_content" }, [
          _c("br"),
          _c("h3", [
            _vm._v(_vm._s(_vm._f("trans")("st_public.Aggregate_Results")))
          ]),
          _c("br"),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm._f(
                  "trans"
                )("st_public.Our program and Hawiyyahs Experts are checking", {
                  websitename: _vm.websiteName
                })
              )
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fe339bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fe339bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/aggregate-results.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6fe339bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/aggregate-results.vue
// module chunks = 50